import React from 'react'
import PropTypes from 'prop-types'

const RowsPerPage = ({
  setRowsPerPage,
  cards,
  disabled,
  rowsPerPage,
  gap = [5, 10, 25, 50]
}) => (
  <div className='form-group d-flex align-items-center'>
    <label className='fw-semibold text-muted text-nowrap me-2' htmlFor='rowsPerPage'>{cards ? 'Items' : 'Rows'} per page:</label>
    <select
      name='rowsPerPage'
      aria-label='rows'
      className='form-select'
      onChange={(e) => setRowsPerPage(e.target.value)}
      value={rowsPerPage}
      disabled={disabled}
    >
      {gap.map((val, i) => (
        <option key={i} value={val}>{val}</option>
      ))}
    </select>
  </div>
)

RowsPerPage.propTypes = {
  setRowsPerPage: PropTypes.func,
  rowsPerPage: PropTypes.number,
  cards: PropTypes.bool,
  gap: PropTypes.array,
  totalPages: PropTypes.number,
  disabled: PropTypes.bool
}

export default RowsPerPage
